import { Button, theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import type { CtaButtonProps } from '../Blocks/CheckoutTicket';

import { handleKeyPress } from 'utils/a11y';

import CheckoutSummaryHeader from './OrderSummarHeader';
import { OrderSummaryPromoCommunication } from './OrderSummaryPromoCommunication';

const LowercaseOrderSummaryPromoCommunication = styled(OrderSummaryPromoCommunication)`
  text-transform: lowercase;
`;

const MobileFooter = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;

  display: flex;
  flex-direction: column;

  width: 100%;
  padding: ${theme.spacing['3x']} ${theme.spacing['4x']};

  background-color: ${theme.colors.neutral[100]};
  box-shadow: 0 0 6px 0 rgb(0 0 0 / 15%);
`;

const Drawer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
`;

const Divider = styled.span`
  width: 100%;
  height: 1px;
  margin: ${theme.spacing['3x']} 0 ${theme.spacing['3x']};
  background-color: ${theme.colors.neutral[600]};
`;

type CartMobileFooterProps = {
  ctaButtonProps?: CtaButtonProps;
  onToggleCart: () => void;
};

export const CartMobileFooter = ({ ctaButtonProps, onToggleCart }: CartMobileFooterProps) => (
  <MobileFooter>
    <>
      <Drawer
        aria-label="Open checkout ticket modal"
        data-click="order-summary-open"
        data-from="cart"
        data-testid="cart-order-summary-drawer"
        onClick={onToggleCart}
        onKeyPress={handleKeyPress(onToggleCart)}
        role="button"
        tabIndex={0}
      >
        <CheckoutSummaryHeader chevronDirection="down" />
      </Drawer>

      {ctaButtonProps && (
        <>
          <Divider />
          <Button
            capsule
            data-testid="mobile-footer-checkout-ticket-button"
            disabled={ctaButtonProps.disabled}
            isLoading={ctaButtonProps.isLoading}
            onClick={ctaButtonProps.onClick}
            size="full"
            style={{
              marginBottom: '4px',
            }}
            type={ctaButtonProps.type}
            variant={ctaButtonProps.variant}
          >
            {ctaButtonProps.text}
          </Button>
        </>
      )}
      <LowercaseOrderSummaryPromoCommunication />
    </>
  </MobileFooter>
);
